import { effect, inject, Injectable, signal, untracked } from "@angular/core"
import { UtilRouteListenerService } from "util/route-listener"
import { User } from "@angular/fire/auth"

@Injectable({
  providedIn: "root",
})
export class AppService {
  private routeService = inject(UtilRouteListenerService)

  callUsElementIsInViewport = signal(true)
  searchTerm = signal("")

  baseUrl = signal("")

  constructor() {
    this.baseUrl.set(location.origin + "/api-v1")

    effect(() => {
      const url = this.routeService.url()
      untracked(() => {
        this.callUsElementIsInViewport.set(url === "/")
      })
    })
  }

}
